<!-- @format -->
<template>
    <div class="footer-widget">
        <div class="widget-container">
            <div class="widget-header">
                <h3>{{ widgetTitle }}</h3>
                <div class="svg-container widget-close-button" @click="closeWidget">
                    <widget-close-svg />
                </div>
            </div>
            <div class="content-wrapper">
                <div v-if="isLoading">
                    <loading-screen-svg />
                </div>
                <div v-else>
                    <footer-starting-step
                        v-if="currentStep === 'startingPoint'"
                        :template-options="templateOptions"
                        :selected-template-option="selectedCreateOption"
                        @input="handleInputCreateOption"
                    />
                    <footer-select-template-step
                        v-if="currentStep === 'existingTemplate'"
                        :footer="footerForm"
                        :client-id="clientId"
                    />
                    <footer-settings-step
                        v-if="currentStep === 'settings'"
                        :account-id="accountId"
                        :is-loading="isLoading"
                        :footer="footerForm"
                    />
                </div>
            </div>
            <div class="widget-footer">
                <app-button class="cancel-btn transparent-btn" size="normal" @click="closeWidget">
                    Cancel
                </app-button>
                <div class="actions-container">
                    <app-button
                        v-if="hasBackAction && !isEditMode && !isReturnDisabled"
                        class="secondary-btn"
                        @click="goBack"
                    >
                        <span class="fa fa-arrow-left"></span>
                        Go Back
                    </app-button>
                    <app-button :disabled="isNextDisabled || isLoading" @click="goNext">
                        Next Step
                        <span class="fa fa-arrow-right"></span>
                    </app-button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import EventBus from '@/scripts/event-bus.js';
import PopUpMixin from '@/mixins/pop-up-mixin';
import { LandingPageSectionService } from '@/scripts/services/landing-page/landing-page-section-service';
import { BrandingService } from '@/scripts/services/magic-branding/branding-service';

const AppButton = () => import('@/components/common/app-button.vue');
const WidgetCloseSvg = () => import('@/components/svg/quick-add/widget-close-svg.vue');
const LoadingScreenSvg = () => import('@/components/svg/loading-screen-svg');
const FooterSettingsStep = () =>
    import('@/components/sliding-widgets/footers/footer-settings-step');
const FooterStartingStep = () =>
    import('@/components/sliding-widgets/footers/footer-starting-step');
const FooterSelectTemplateStep = () =>
    import('@/components/sliding-widgets/footers/footer-select-template-step');

export default {
    name: 'footer-widget',

    components: {
        'app-button': AppButton,
        'widget-close-svg': WidgetCloseSvg,
        'loading-screen-svg': LoadingScreenSvg,
        'footer-settings-step': FooterSettingsStep,
        'footer-starting-step': FooterStartingStep,
        'footer-select-template-step': FooterSelectTemplateStep,
    },

    mixins: [PopUpMixin],

    props: {
        widget: {
            type: Object,
            required: true,
        },
    },

    data() {
        return {
            footerForm: {
                name: '',
                categories: [],
                configuration: {
                    structure: {
                        name: '',
                        type: 'nav-and-copyright',
                        isNavOnlyOrNavAndCopyright: true,
                        isCopyrightOnlyOrNavAndCopyright: true,
                    },

                    topbar: {
                        style: {
                            fontSize: '16px',
                            fontFamily:
                                "Roboto, Helvetica, Arial, Tahoma, 'Franklin Gothic Medium', sans-serif",

                            fontColor: { value: '#141414', branding: null, name: null },
                            linkColor: { value: '#ffffff', branding: null, name: null },
                            backgroundColor: { value: '#382153', branding: null, name: null },
                        },

                        menu: [
                            { name: 'Home', url: 'https://mywebsite.com/' },
                            { name: 'Contact Us', url: 'https://mywebsite.com/' },
                            { name: 'Careers', url: 'https://mywebsite.com/' },
                            { name: 'Support Portal', url: 'https://mywebsite.com/' },
                            { name: 'Sitemap', url: 'https://mywebsite.com/' },
                        ],

                        isMenuEnabled: true,
                        socialMedia: {
                            isEnabled: true,
                            data: [
                                {
                                    name: 'Twitter',
                                    url: 'https://twitter.com/',
                                    color: { value: '#ffffff' },
                                    isEnabled: true,
                                    isTwitter: true,
                                    isFacebook: false,
                                    isInstagram: false,
                                    isWebsite: false,
                                    isLinkedin: false,
                                },
                                {
                                    name: 'Instagram',
                                    url: 'https://instagram.com/',
                                    color: { value: '#ffffff', branding: null, name: null },
                                    isEnabled: true,
                                    isTwitter: false,
                                    isFacebook: false,
                                    isInstagram: true,
                                    isWebsite: false,
                                    isLinkedin: false,
                                },
                                {
                                    name: 'Facebook',
                                    url: 'https://facebook.com/',
                                    color: { value: '#ffffff', branding: null, name: null },
                                    isEnabled: true,
                                    isTwitter: false,
                                    isFacebook: true,
                                    isInstagram: false,
                                    isWebsite: false,
                                    isLinkedin: false,
                                },
                                {
                                    name: 'Linkedin',
                                    url: 'https://linkedin.com/',
                                    color: { value: '#ffffff', branding: null, name: null },
                                    isEnabled: true,
                                    isTwitter: false,
                                    isFacebook: false,
                                    isInstagram: false,
                                    isWebsite: false,
                                    isLinkedin: true,
                                },
                                {
                                    name: 'Website',
                                    url: 'https://mywebsite.com/',
                                    color: { value: '#ffffff', branding: null, name: null },
                                    isEnabled: true,
                                    isTwitter: false,
                                    isFacebook: false,
                                    isInstagram: false,
                                    isWebsite: true,
                                    isLinkedin: false,
                                },
                                {
                                    name: 'Youtube',
                                    url: 'https://youtube.com/',
                                    color: { value: '#ffffff', branding: null, name: null },
                                    isEnabled: true,
                                    isTwitter: false,
                                    isFacebook: false,
                                    isInstagram: false,
                                    isWebsite: false,
                                    isLinkedin: false,
                                    isYoutube: true,
                                },
                            ],
                        },
                    },

                    bottombar: {
                        style: {
                            fontSize: '14px',
                            fontFamily:
                                "Roboto, Helvetica, Arial, Tahoma, 'Franklin Gothic Medium', sans-serif",

                            fontColor: { value: '#ffffff', branding: null, name: null },
                            linkColor: { value: '#141414', branding: null, name: null },
                            backgroundColor: { value: '#7A5BFF', branding: null, name: null },
                        },

                        copyrightText: '© Lorem Ipsum 2018 | Privacy Policy',
                    },
                },
            },

            isLoading: false,
            selectedCreateOption: null,
            currentStep: 'startingPoint',
            lastActiveStep: null,
            promoId: null,
            isReturnDisabled: false,
            templateOptions: [
                {
                    imageUrl: require('@/assets/images/footers-fresh.png'),
                    name: 'Start Fresh',
                    value: 'settings',
                },
                {
                    imageUrl: require('@/assets/images/footers-templates.png'),
                    name: 'Existing Template',
                    value: 'existingTemplate',
                },
            ],

            steps: {
                startingPoint: {
                    title: 'Create a Template',
                    actions: {
                        nextAction: {
                            label: 'Next Step',
                            callback: () => {
                                this.goToStep(this.selectedCreateOption.value);
                            },
                        },
                    },
                },

                existingTemplate: {
                    title: 'Select a Template',
                    actions: {
                        nextAction: {
                            label: 'Next Step',
                            callback: () => {
                                this.goToStep('settings');
                            },
                        },

                        backAction: {
                            label: 'Go Back',
                            callback: () => {
                                this.formConfig = {
                                    ...this.defaultFormConfig,
                                };
                                this.goToStep('startingPoint');
                            },
                        },
                    },
                },

                settings: {
                    title: 'Create Footer Template',
                    actions: {
                        nextAction: {
                            label: 'Next Step',
                            callback: () => {
                                this.saveFooter();
                            },
                        },

                        backAction: {
                            label: 'Go Back',
                            callback: () => {
                                this.goToStep(this.lastActiveStep);
                            },
                        },
                    },
                },
            },
        };
    },

    computed: {
        accountId() {
            return this.widget.options.accountId;
        },

        clientId() {
            return this.widget.options.clientId;
        },

        baseUrl() {
            return this.$store.getters.baseUrl;
        },

        footerId() {
            return this.widget.options.footerId;
        },

        isFromTemplate() {
            return this.widget.options.isFromTemplate;
        },

        isLandingPage() {
            return this.widget.options.isLandingPage;
        },

        widgetTitle() {
            if (this.isEditMode) {
                return 'Edit Footer';
            }

            return this.steps[this.currentStep].title;
        },

        isEditMode() {
            return (
                this.widget.options.footerId !== null && this.widget.options.footerId !== undefined
            );
        },

        isNextDisabled() {
            if (this.currentStep === 'settings' || this.currentStep === 'existingTemplate') {
                return this.footerForm.name.length <= 0;
            }
            return false;
        },

        hasBackAction() {
            return (
                this.steps[this.currentStep].actions.backAction !== undefined &&
                !this.isFromTemplate
            );
        },

        goBack() {
            return this.steps[this.currentStep].actions.backAction.callback;
        },

        goNext() {
            return this.steps[this.currentStep].actions.nextAction.callback;
        },

        footerConfig() {
            return this.footerForm.configuration;
        },
    },

    created() {
        if (this.isEditMode || this.isFromTemplate) {
            this.getFooterData();
            this.goToStep('settings');
        } else if (this.clientId) {
            this.isLoading = true;

            this.getBranding();
            this.getPromoId().then(() => {
                Promise.all(this.getTotalFootersCount())
                    .then((counts) => {
                        const total = counts.reduce((acc, count) => acc + count, 0);

                        if (total === 0) {
                            this.isReturnDisabled = true;
                            return this.goToStep('settings');
                        }
                    })
                    .catch((error) => {
                        this.$helpers.showFailNotification(
                            'Failed to get total footer templates.',
                            { error },
                        );
                    })
                    .finally(() => {
                        this.isLoading = false;
                    });
            });
        } else {
            this.isLoading = true;

            const filter = `Type eq TriDigital.EntityDomain.Entities.LandingPageSectionType'Footer' and AccountId eq ${this.accountId} and (SharedAssets/any() or not SharedAssets/any())&$top=0`;

            this.getTemplatesCount(filter)
                .then((count) => {
                    if (count === 0) {
                        this.isReturnDisabled = true;
                        return this.goToStep('settings');
                    }
                })
                .catch((error) => {
                    this.$helpers.showFailNotification('Failed to get total footer templates.', {
                        error,
                    });
                })
                .finally(() => {
                    this.isLoading = false;
                });
        }

        this.selectedCreateOption = this.templateOptions[0];
    },

    methods: {
        closeWidget() {
            EventBus.$emit('close-widget', this.widget);
        },

        handleInputCreateOption(createOptionSelected) {
            this.selectedCreateOption = createOptionSelected;
        },

        getFooterData() {
            this.isLoading = true;

            LandingPageSectionService.get(this.footerId)
                .then(({ data }) => {
                    this.footerForm = {
                        name: data.value[0].Name,
                        categories: this.isFromTemplate
                            ? []
                            : data.value[0].Categories.map(({ Name }) => Name),
                        configuration: JSON.parse(data.value[0].Configuration),
                    };

                    this.goToStep('settings');
                })
                .catch((error) => {
                    this.$helpers.showFailNotification(
                        'An error ocurred while getting your footer data.',
                        { error },
                    );
                })
                .finally(() => {
                    this.isLoading = false;
                });
        },

        createFooter() {
            const isUsingTemplate =
                this.isFromTemplate || this.selectedCreateOption.value === 'existingTemplate';

            const body = {
                name: this.footerForm.name,
                categories: this.footerForm.categories,
                configuration: JSON.stringify(this.footerForm.configuration),
                accountId: this.accountId,
                type: 'footer',
            };

            LandingPageSectionService.post(body)
                .then(({ data }) => {
                    this.$helpers.showSuccessNotification(
                        isUsingTemplate
                            ? 'Your footer has been created'
                            : 'Your footer has been created with default settings.',
                    );

                    this.$router.push(`${this.baseUrl}/LandingPages/Footers/${data.Id}`);
                    EventBus.$emit('close-widgets');
                })
                .catch((error) => {
                    this.$helpers.showFailNotification(
                        'An error ocurred while creating your footer.',
                        { error },
                    );
                })
                .finally(() => {
                    this.isLoading = false;
                });
        },

        patchFooter() {
            this.footerConfig.structure.name = this.footerForm.name;

            const body = [
                {
                    name: 'Name',
                    value: this.footerForm.name,
                },
                {
                    name: 'Categories',
                    value: this.footerForm.categories,
                },
                {
                    name: 'Configuration',
                    value: JSON.stringify(this.footerForm.configuration),
                },
            ];

            LandingPageSectionService.patch(this.footerId, body)
                .then(() => {
                    this.$helpers.showSuccessNotification(
                        'Your footer has been updated with default settings.',
                    );

                    this.$router.push(`${this.baseUrl}/LandingPages/Footers/${this.footerId}`);
                    EventBus.$emit('close-widgets');
                })
                .catch((error) => {
                    this.$helpers.showFailNotification(
                        'An error ocurred while updating your footer.',
                        { error },
                    );
                })
                .finally(() => {
                    this.isLoading = false;
                });
        },

        saveFooter() {
            if (this.isLandingPage) {
                return this.showCreateConfirmPopup();
            }

            this.isLoading = true;

            if (this.isEditMode && !this.isFromTemplate) {
                this.patchFooter();
            } else {
                this.createFooter();
            }
        },

        goToStep(step) {
            this.lastActiveStep = this.currentStep;
            this.currentStep = step;
        },

        getTemplatesCount(filter) {
            return new Promise((resolve, reject) => {
                LandingPageSectionService.getAll({
                    filter: filter,
                    count: true,
                })
                    .then(({ data }) => {
                        const totalTemplates = data['@odata.count'];
                        resolve(totalTemplates);
                    })
                    .catch(reject);
            });
        },

        getTotalFootersCount() {
            const myTemplatesCountfilter = `Type eq TriDigital.EntityDomain.Entities.LandingPageSectionType'Footer' and  (AccountId eq ${this.accountId})&$top=0`;
            const sharedTemplatesCountfilter = `Type eq TriDigital.EntityDomain.Entities.LandingPageSectionType'Footer' and SharedAssets/any(a: a/AgencyClient/ClientId eq  ${this.clientId} or a/PromoId eq ${this.promoId})&$top=0`;

            return [
                this.getTemplatesCount(myTemplatesCountfilter),
                this.getTemplatesCount(sharedTemplatesCountfilter),
            ];
        },

        getPromoId() {
            return new Promise((resolve, reject) => {
                LandingPageSectionService.getClient(this.clientId, {
                    select: 'PromoId',
                })
                    .then((response) => {
                        this.promoId = response.data.value[0].PromoId;
                        resolve();
                    })
                    .catch((error) => {
                        this.$helpers.showFailNotification(
                            'An error occurred while getting your headers.',
                            { error },
                        );
                        reject();
                    });
            });
        },

        getBranding() {
            const filter = `clientId=${this.clientId}`;

            return new Promise((resolve, reject) => {
                BrandingService.get(filter)
                    .then(({ data }) => {
                        const branding = JSON.parse(data.Configuration);

                        this.footerConfig.topbar.style.fontColor.value =
                            branding.colors.fontColors.bodyText.value;
                        this.footerConfig.topbar.style.fontSize = `${branding.fonts.landingPage.bodyText.fontSize}px`;
                        this.footerConfig.topbar.style.linkColor.value =
                            branding.colors.fontColors.linkColor.value;
                        this.footerConfig.topbar.style.backgroundColor.value =
                            branding.colors.landingPageColors.backgroundColor.value;
                        this.footerConfig.topbar.style.fontFamily =
                            branding.fonts.landingPage.bodyText.fontFamily.value;

                        this.footerConfig.bottombar.style.fontColor.value =
                            branding.colors.fontColors.bodyText.value;
                        this.footerConfig.bottombar.style.fontSize = `${branding.fonts.landingPage.bodyText.fontSize}px`;
                        this.footerConfig.bottombar.style.linkColor.value =
                            branding.colors.fontColors.linkColor.value;
                        this.footerConfig.bottombar.style.backgroundColor.value =
                            branding.colors.landingPageColors.backgroundColor.value;
                        this.footerConfig.bottombar.style.fontFamily =
                            branding.fonts.landingPage.bodyText.fontFamily.value;

                        resolve();
                    })
                    .catch((error) => {
                        this.$helpers.showFailNotification(
                            'There was an error retrieving your branding',
                            { error },
                        );
                        reject();
                    });
            });
        },

        showCreateConfirmPopup() {
            const actions = {
                confirm: {
                    label: 'Ok',
                    action: () => {
                        this.createFooter();
                    },
                },

                cancel: {
                    label: 'Cancel',
                },
            };

            const modalProps = {
                title: 'Are you sure?',
                content: '<p>By doing this you will lose your unsaved progress.</p>',
                actions,
            };

            this.showPopup(modalProps, 'alert-popup');
        },
    },
};
</script>

<style>
.footer-widget .widget-container {
    width: 100%;
    height: 100%;
}

.footer-widget .widget-container .content-wrapper {
    padding: 23px 29px 23px 33px;
}

.footer-widget .content-wrapper .loading-screen {
    text-align: center;
}

.footer-widget .cancel-btn {
    background: transparent;
    color: #877d88;
    border: none;
}

.footer-widget .cancel-btn:hover {
    background: #e1e0e5;
}

.footer-widget .save-btn {
    background: #18aeff;
}

.footer-widget .save-btn:hover {
    background: var(--color-fill-accent-skyblue-medium); /*mass replace */
}

.footer-widget .widget-footer .actions-container {
    display: flex;
}

.footer-widget .widget-footer .secondary-btn {
    background: transparent;
    border: 1px solid #18aeff;
    color: #18aeff;
    margin-right: 14px;
}

.footer-widget .widget-footer .secondary-btn span.fa {
    margin-right: 10px;
}

.footer-widget .widget-footer .app-button:not(.secondary-btn) span.fa {
    margin-left: 10px;
}
</style>
